module.exports = __webpack_public_path__ + "media/components/theme/fonts/icomoon-4d73887751e0fe82581366a9587b016f.ttf";